<template>
	<div class="content text-white">
		<div class="text-3.5xl mb-3">Riwayat Withdrawal Tunai</div>
		<div class="text-xs mb-8">
			<Breadcrumbs />
		</div>

		<!-- filter -->
		<div>
			<div class="flex justify-end gap-3 mb-3">
				<div>
					<FilterPeriode ref="filterPeriodeRef" :fromDate.sync="fromDate" :toDate.sync="toDate" @dateChanged="handlePeriodeChange" />
				</div>
				<div>
					<FilterStatus ref="filterStatusRef" :status.sync="statusChosen" />
				</div>
				<div>
					<input class="input w-full" type="text" placeholder="Masukkan kata kunci" v-model="search">
				</div>
			</div>
		</div>

		<!-- table -->
		<div>
			<table class="table-new">
				<thead>
					<tr>
						<th>Tanggal</th>
						<th>Transaction ID</th>
						<th>Withdrawal Account Number</th>
						<th>Status</th>
						<th>Nominal</th>
						<th>Biaya Admin</th>
						<th>Detail</th>
					</tr>
				</thead>
				<tbody>
					<template v-if="withdrawals.length <= 0">
						<tr>
							<td colspan="7" class="text-center">
								<div class="text-1.5xl font-bold">Belum Ada Data</div>
								<div>Anda belum memiliki riwayat withdrawal</div>
							</td>
						</tr>
					</template>

					<template v-else>
						<tr v-for="withdrawal in withdrawals">
							<td class="text-center">{{ withdrawal.date }}</td>
							<td class="text-center">{{ withdrawal.transactionId }}</td>
							<td class="text-center">{{ withdrawal.credit.RpedNumber }}</td>
							<td class="text-center">{{ withdrawal.status }}</td>
							<td class="text-center">{{ withdrawal.amount }}</td>
							<td class="text-center">{{ withdrawal.adminFee }}</td>
							<td class="text-center">
								<button class="btn outline btn-small w-full" @click="openDetail(withdrawal._id)">Lihat</button>
							</td>
						</tr>
					</template>
				</tbody>
			</table>
		</div>

		<DetailRiwayatWithdrawal ref="detailRiwayatWithdrawalRef" />
	</div>
</template>

<script>
import useBankAccount from '../../composable/useBankAccount'
import Breadcrumbs from '../../components/Breadcrumbs.vue'
import FilterPeriode from './components/FilterPeriode.vue'
import FilterStatus from './components/FilterStatus.vue'

import DetailRiwayatWithdrawal from './components/DetailRiwayatWithdrawal.vue'
import IconCheck from '../../components/icons/IconCheck.vue'
import { search } from 'core-js/fn/symbol'

export default {
	name: 'RiwayatWithdrawalTunai',

	mixins: [useBankAccount],

	components: {
		Breadcrumbs,
		FilterPeriode,
		FilterStatus,
		DetailRiwayatWithdrawal,
		IconCheck,
	},

	data() {
		return {
			withdrawals: [],
			fromDate: "",
			toDate: "",
			search: "",
			statusChosen: "Semua",
		}
	},

	created() {
		this.getWithdrawalsFunc()
	},

	mounted() {
		this.$refs.filterStatusRef.setFilterStatus([
			{ value: 'Semua', label: 'Semua' },
			{ value: 'Diproses', label: 'Diproses' },
			{ value: 'Berhasil', label: 'Berhasil' },
			{ value: 'Gagal', label: 'Gagal' },
		])
	},

	computed: {
		// watch fromDate, toDate, search, statusChosen
		triggerFilter() {
			return this.search + this.statusChosen
		},
	},

	watch: {
		listWithdrawals() {
			this.withdrawals = this.listWithdrawals
		},

		// search(newVal) {
		// 	// search transactionId, amount, credit rped number, credit acount name, debit account name
		// 	this.withdrawals = this.listWithdrawals.filter((withdrawal) => {
		// 		return withdrawal.transactionId.includes(newVal)
		// 	})
		// },

		triggerFilter() {
			this.setWithdrawals()
		}
	},

	methods: {
		openDetail(withdrawalId) {
			const withdrawalDetail = this.listWithdrawals.find((withdrawal) => withdrawal._id === withdrawalId)
			this.$refs.detailRiwayatWithdrawalRef.setWithdrawalDetail(withdrawalDetail)
			this.$refs.detailRiwayatWithdrawalRef.open()
		},

		setWithdrawals() {
			// filter periode
			let filteredWithdrawals = this.listWithdrawals.filter((withdrawal) => {
				if (!this.fromDate || !this.toDate) return true

				const date = new Date(withdrawal.dateRaw)
				const fromDate = new Date(this.fromDate)
				const toDate = new Date(this.toDate)

				return date >= fromDate && date <= toDate
			})

			// filter status
			if (this.statusChosen !== 'Semua') {
				filteredWithdrawals = filteredWithdrawals.filter((withdrawal) => withdrawal.status === this.statusChosen)
			}

			// search
			if (this.search) {
				filteredWithdrawals = filteredWithdrawals.filter((withdrawal) => {
					const transactionId = withdrawal.transactionId.toLowerCase()
					const creditRpedNumber = withdrawal.credit.RpedNumber.toLowerCase()
					const creditAccountName = withdrawal.credit.accountName.toLowerCase()
					const creditBankName = withdrawal.credit.bankName.toLowerCase()
					const debitAccountNumber = withdrawal.debit.accountNumber.toLowerCase()
					const debitAccountName = withdrawal.debit.accountName.toLowerCase()
					const debitBankName = withdrawal.debit.bankName.toLowerCase()
					const description = withdrawal.description.toLowerCase()

					return transactionId.includes(this.search.toLowerCase()) ||
						creditRpedNumber.includes(this.search.toLowerCase()) ||
						creditAccountName.includes(this.search.toLowerCase()) ||
						creditBankName.includes(this.search.toLowerCase()) ||
						debitAccountNumber.includes(this.search.toLowerCase()) ||
						debitAccountName.includes(this.search.toLowerCase()) ||
						debitBankName.includes(this.search.toLowerCase()) ||
						description.includes(this.search.toLowerCase())
				})
			}

			this.withdrawals = filteredWithdrawals
		},

		handlePeriodeChange() {
			this.setWithdrawals()
		}
	}
}
</script>

<style scoped></style>